export const translations = {
  en: {
    digitalCheckIn: {
      arrival: 'Arrive: {{arrivalTime}}',
      arrivedHeader:
        'Thanks {{firstName}}, you’re checked in. We will call you in when {{providerDisplayName}} is ready.',
      arrivedSubheader:
        'If you have any questions, don’t hesitate to ask our staff at the front desk.',
      checkInHeader:
        'Confirm you are in the correct location for your appointment',
      checkInLoadingHeader: 'Checking you in...',
      checkInLoadingSubheader:
        'Reviewing your patient information and notifying our staff of your arrival. This may take up to 10 seconds to complete.',
      checkInSubheader:
        'Please only confirm if you are physically inside the clinic listed below.',
      confirmAndCheckIn: 'Confirm & check-in',
      confirmationDescription:
        'Digital check-in requires you to be the patient or legal guardian. If you are not, please check-in with the front desk.',
      confirmationTitle: 'Are you the patient or legal guardian?',
      directionsHeader: 'Getting to your appointment:',
      errorHeader: 'There was a problem checking you in',
      errorSubheader:
        'Please go to the front desk and we can help you complete your check-in.',
      expiredHeader: 'Digital check-in time has expired',
      expiredSubheader:
        'Please go to the front desk and we can help you complete your check-in.',
      incorrectLocationHeader: 'Not at the right location?',
      incorrectLocationSubheader:
        'Go to the front desk and we can help you find the right location.',
      instructionsHeader:
        'Here are some instructions to help you prepare for your upcoming appointment:',
      loadingHeader: 'Loading...',
    },
  },
  es: {
    digitalCheckIn: {
      arrival: 'Llegada: {{arrivalTime}}',
      arrivedHeader:
        'Gracias, {{firstName}}, ya estás registrado. Te llamaremos cuando {{providerDisplayName}} esté listo.',
      arrivedSubheader:
        'Si tiene alguna pregunta, no dude en preguntar a nuestro personal en la recepción.',
      checkInHeader: 'Confirme que está en la ubicación correcta para su cita',
      checkInLoadingHeader: 'Registrándote...',
      checkInLoadingSubheader:
        'Revisando la información de su paciente y notificar a nuestro personal de su llegada. Esto puede tardar hasta 10 segundos en completarse.',
      checkInSubheader:
        'Confirme solo si se encuentra físicamente dentro de la clínica que se detalla a continuación.',
      confirmAndCheckIn: 'Confirmar y registrarse',
      confirmationDescription:
        'El registro digital requiere que seas el paciente o tutor legal. Si no es así, regístrese en la recepción.',
      confirmationTitle: '¿Eres la paciente o tutor(a) legal?',
      directionsHeader: 'Cómo llegar a su cita:',
      errorHeader: 'Hubo un problema al registrarte',
      errorSubheader:
        'Dirígete a la recepción y podremos ayudarte a completar tu registro.',
      expiredHeader: 'El tiempo de registro digital ha expirado',
      expiredSubheader:
        'Dirígete a la recepción y podremos ayudarte a completar tu registro.',
      incorrectLocationHeader: '¿No estás en el lugar correcto?',
      incorrectLocationSubheader:
        'Dirígete a la recepción y te ayudaremos a encontrar la ubicación adecuada.',
      instructionsHeader:
        'Aquí hay algunas instrucciones que lo ayudarán a prepararse para su próxima cita:',
      loadingHeader: 'Cargando...',
    },
  },
};
